module.exports = __webpack_public_path__ + "img/interact-answer-btn-disabled.939bff1c.png";